import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// CSS Import
import "./index.css";

// REDUX Import
import { setCurrentMenu } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

// MENU Import
import MenuItemCardmobile from "../../MenuItemCardmobile";

// UTLIS Imports
import checkIfEnable from "../../../../utils/checkIfEnable";

// SERVICES Import
import ServiceIDByLabel from "../../../../services/ServiceIDByLabel";

export default function MobileViewPopover(props) {
  // useDispatch
  const dispatch = useDispatch();

  // useRef
  const elementRef = useRef(null);

  // useState
  const [flowType, setFlowType] = useState(false);
  const [isPopoverClosing, setIsPopoverClosing] = useState(false);

  // useSelector
  const services_list = useSelector((state) => state.refreshToken.services);
  const setOpenMobilePopover = props.setOpenMobilePopover;

  // useEffect
  useEffect(() => {
    setFlowType(
      props.data[0].title.includes("Transaction") ? "Transactions" : "Accounts",
    );
  }, []);

  const handleTogglePopover = () => {
    setIsPopoverClosing(true);
    setTimeout(() => {
      setOpenMobilePopover(false);
      setIsPopoverClosing(false);
    }, 200);
  };

  const hidePopover = () => {
    setIsPopoverClosing(true);
    setTimeout(() => {
      setOpenMobilePopover(false);
      setIsPopoverClosing(false);
    }, 200);
  };

  return (
    <div>
      <div
        onClick={() => {
          hidePopover();
        }}
        className="overlay absolute"
      ></div>
      {["bottom"].map((anchor) => (
        <div
          key={anchor}
          ref={elementRef}
          className={`popover-main-mobile relative py-padding_mb ${
            isPopoverClosing ? "closing" : "open"
          }`}
          style={{ backgroundColor: "var(--primary-card)" }}
        >
          <div
            className="menudiv"
            style={{
              width: "var(--width-full)",
              boxShadow: "none",
              margin: "auto",
              flexGrow: 1,
              height: "auto",
              cursor: "pointer",
            }}
          >
            <div className="border border-primary-act m-margin-button-l mt-top_md rounded-border-radius-md bg-primary-nav">
              {props.data.map((transaction, index) =>
                transaction.title !== "Admin Transactions" ? (
                  <div
                    key={index}
                    className="w-full"
                  >
                    {index > 0 && (
                      <div className="border-b border-[var(--brand-primary-surface-default)] mx-margin-sm"></div>
                    )}

                    <div className="mt-margin-sm mb-margin-sm px-padding-sm text-text-primary text-font-md font-semibold">
                      {transaction.title}
                    </div>
                    <div>
                      {transaction.menuItems.map((menuItem, itemIndex) => (
                        <Link
                          key={itemIndex}
                          to={
                            checkIfEnable(
                              ServiceIDByLabel,
                              menuItem.label,
                              services_list,
                            )
                              ? `/${menuItem.route}`
                              : "/feature_not_assigned"
                          }
                          style={{
                            "textDecoration": "none",
                            "pointerEvents": "auto",
                            "backgroundColor": checkIfEnable(
                              ServiceIDByLabel,
                              menuItem.label,
                              services_list,
                            )
                              ? "var(--text-primary)"
                              : "var(--text-secondary)",
                            "&:hover": checkIfEnable(
                              ServiceIDByLabel,
                              menuItem.label,
                              services_list,
                            ) && {
                              backgroundColor: "var(--text-primary)",
                              cursor: "pointer",
                            },
                            "opacity": checkIfEnable(
                              ServiceIDByLabel,
                              menuItem.label,
                              services_list,
                            )
                              ? "var(--base-opacity)"
                              : "var(--light-opacity)",
                          }}
                          onClick={() => {
                            dispatch(setCurrentMenu(menuItem.menu));
                            handleTogglePopover();
                          }}
                        >
                          <MenuItemCardmobile
                            icon={menuItem.icon}
                            labelm={menuItem.labelm}
                            labela={menuItem.labela}
                          />
                        </Link>
                      ))}
                    </div>
                  </div>
                ) : null,
              )}
            </div>
            <div
              style={{
                fontSize: "var(--font-xs)",
                color: "var(--text-secondary)",
                padding: "var(--padding-base) var(--padding-md)",
                marginBottom: "var(--margin-md)",
                marginTop: "var(--margin-md)",
              }}
            >
              *If disabled - the feature is not available for your ID.
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
